import type { PushProduct } from "./data"
import { TODAY, daysBetween } from "./dates"

// Stock per warehouse and incoming orders, from the sheet.

// The order of PushProduct.stockByWarehouse. The first four each serve one
// channel (MKP = Shopee + TikTok Shop + Lazada); Master and the stores serve
// none, so the sheet has no units out for them.
export const WAREHOUSES = ["Boxme MKP", "Boxme Ecom", "Viettel Post - Wholesale", "Viettel Post - Retail", "Viettel Post - Master", "Stores"]

export interface Site {
  warehouse: string
  qty: number
  outPerDay: number | null // null when the warehouse serves no channel
}

export function hash(text: string) {
  return [...text].reduce((sum, c) => sum + c.charCodeAt(0), 0)
}

export const oneDecimal = (n: number) => Math.round(n * 10) / 10

export const channelOutPerDay = (product: PushProduct, i: number) =>
  i < product.out60.length ? oneDecimal(product.out60[i] / 60) : null

export function sitesOf(product: PushProduct): Site[] {
  return product.stockByWarehouse
    .map((qty, i) => ({ warehouse: WAREHOUSES[i], qty, outPerDay: channelOutPerDay(product, i) }))
    .filter((site) => site.qty > 0)
}

// How long stock lasts at the current pace, in days. Null when nothing moves.
export function lastsDays(qty: number, outPerDay: number) {
  return outPerDay > 0 ? Math.round(qty / outPerDay) : null
}

// How long the stock lasts once the incoming order lands, counting what goes
// out before it arrives.
export function afterIncoming(product: PushProduct) {
  if (!product.incoming) return null
  const { qty, arrives } = product.incoming
  const leftOnArrival = Math.max(0, product.stock - product.outPerDay * daysBetween(TODAY, arrives))
  return { qty, arrives, lasts: lastsDays(leftOnArrival + qty, product.outPerDay) }
}
